import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SeFeToastModule } from 'se-fe-toast'
import { SharedUiNameModule } from '../lib/shared-ui-name.module'
import { NameExampleComponent } from './name-docs/examples/name-example.component'
import { PopulatedNameExampleComponent } from './name-docs/examples/populated-name-example.component'
import { SuffixPreferredNameExampleComponent } from './name-docs/examples/suffix-preferred-name-example.component'
import { NameDocsComponent } from './name-docs/name-docs.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeFeToastModule,
    SharedUiNameModule
  ],
  declarations: [
    NameDocsComponent,
    NameExampleComponent,
    PopulatedNameExampleComponent,
    SuffixPreferredNameExampleComponent
  ],
  exports: [
    NameDocsComponent
  ]
})
export class SharedUiNameDocsModule {}
